import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=73dc92b4&scoped=true&"
import script from "./roleManagement.vue?vue&type=script&lang=js&"
export * from "./roleManagement.vue?vue&type=script&lang=js&"
import style0 from "./roleManagement.vue?vue&type=style&index=0&id=73dc92b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc92b4",
  null
  
)

export default component.exports